import { createSelector } from 'reselect';
import checkFeatureFlag from 'utils/featureFlags';
export const selectHasLiveExportFeature = createSelector((store) => store.utils.featureFlags, (featureFlags) => checkFeatureFlag(featureFlags, 'live_export'));
